module.exports = __webpack_public_path__ + "static/nw-86785c8b10366052c9c8d75e69b0f397.jpg";